var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`info-panel ${_vm.styleClass || ''} ${
    _vm.isShowing ? 'showing' : 'hidden'
  }`},[_vm._v(" "+_vm._s(_vm.text)+" "),(_vm.canBeClosed)?_c('el-button',{staticClass:"close-button",attrs:{"icon":"el-icon-close","type":"text"},on:{"click":_vm.close}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }